import { useState } from "react";
import { IncidentInbox } from "@/components/platform/incidents/IncidentInbox";
import { CopilotDrawer } from "@/components/platform/copilot/CopilotDrawer";
import { SEO } from "@/components/SEO";
import type { TenantIncident } from "@/hooks/useTenantIncidents";
import type { CopilotTenantContext } from "@/hooks/useCopilot";

const PlatformIncidents = () => {
  const [copilotOpen, setCopilotOpen] = useState(false);
  const [copilotContext, setCopilotContext] = useState<CopilotTenantContext | null>(null);

  const handleInvestigate = (incident: TenantIncident) => {
    setCopilotContext({
      companyId: incident.company_id,
      companyName: incident.tenant_name ?? "Unknown",
    });
    setCopilotOpen(true);
  };

  return (
    <div className="space-y-6">
      <SEO title="Incidents — Platform Admin" description="Tenant incident management" />

      <div>
        <h1 className="text-2xl font-bold">Incidents</h1>
        <p className="text-sm text-muted-foreground">
          Monitor and manage tenant health issues detected by the observer
        </p>
      </div>

      <IncidentInbox onInvestigate={handleInvestigate} />

      <CopilotDrawer
        open={copilotOpen}
        onOpenChange={setCopilotOpen}
        initialTenantContext={copilotContext}
      />
    </div>
  );
};

export default PlatformIncidents;
